import Visibility from 'visibilityjs'
export const isHidden = () => {
  return 'hidden' === Visibility.state()
}